<template>
  <x-list-page
      ref="listPage"
      :button-config="buttonConfig"
      :condition-config="conditionConfig"
      columnCache="SysLog"
      :columns="columns">
  </x-list-page>
</template>

<script>
import listPageConfigMixin from '@/component/x-list-page/list-page-config-mixin';
import request from '@/util/request2';
import {FIELD_TYPE_DATE, FIELD_TYPE_INPUT} from '@/util/x-condition-constant';
import {getConditionItem} from '@/util/componentCoreUtil';
import {DATE_FORMAT, dateFormat} from '@/util/appUtils';

export default {
  name: 'SysLog',
  mixins: [listPageConfigMixin],
  props: {
    menu: String,
    targetNo: String
  },
  data() {
    const date = new Date();
    const endDate = dateFormat(DATE_FORMAT, date);
    date.setDate(date.getDate() - 29);
    const startDate = dateFormat(DATE_FORMAT, date);
    return {
      api: (params) => {
        return request({
          url: '/api/auth/sysLog/pager',
          method: 'post',
          data: params
        });
      },
      buttonConfig: {
        list: [
          {
            name: '查询',
            click: this.reLoadData
          }
        ]
      },
      conditionConfig: {
        labelWidth: '116px',
        model: {
          startDate,
          endDate
        },
        rules: {},
        list: [
          {
            field: 'startDate',
            label: '开始日期',
            placeholder: '请选择',
            valueFormat: DATE_FORMAT,
            type: FIELD_TYPE_DATE
          },
          {
            field: 'endDate',
            label: '结束日期',
            placeholder: '请选择',
            valueFormat: DATE_FORMAT,
            type: FIELD_TYPE_DATE
          },
          {
            field: 'targetNo',
            label: '单号',
            type: FIELD_TYPE_INPUT,
            enter: this.reLoadData
          },
          {
            field: 'menu',
            label: '菜单模块',
            type: FIELD_TYPE_INPUT,
            enter: this.reLoadData
          },
          {
            field: 'optName',
            label: '操作人',
            type: FIELD_TYPE_INPUT,
            placeholder: '请输入',
            enter: this.reLoadData
          },
          {
            field: 'optContent',
            label: '操作内容',
            type: FIELD_TYPE_INPUT,
            placeholder: '请输入',
            enter: this.reLoadData
          }
        ]
      },
      columns: [
        {field: 'seq', type: 'seq', title: '序号', width: 50, align: 'center', fixed: 'left'},
        {field: 'creatorName', title: '操作人', align: 'center', width: 100},
        {field: 'createTime', title: '操作时间', align: 'center', width: 160, sortable: true},
        {field: 'menu', title: '菜单模块', align: 'center', width: 100},
        {field: 'targetNo', title: '单号', align: 'center', width: 180, sortable: true},
        {field: 'targetId', title: '单号id', align: 'center', width: 100},
        {field: 'detailVersion', title: '单据明细/版本', align: 'center', width: 100},
        {field: 'detailId', title: '单据明细id', align: 'center', width: 100},
        {field: 'opt', title: '操作', align: 'center', width: 100},
        {field: 'optContent', title: '操作内容', align: 'center', minWidth: 300}
      ],
    };
  },
  mounted() {
    if (this.targetNo) {
      this.conditionConfig.model.targetNo = this.targetNo;
      getConditionItem({list: this.conditionConfig.list, field: 'targetNo'}).disabled = true;
    }
    if (this.menu) {
      this.conditionConfig.model.menu = this.menu;
      getConditionItem({list: this.conditionConfig.list, field: 'menu'}).disabled = true;
    }
    this.reLoadData();
  }
};
</script>

<style scoped>

</style>